import React from 'react'

import { Observe } from '~components/Markdown'
import style from './Choice.module.scss'

const Choice = ({
  option,
  value,
  color = '',
  unset = false,
  lazy = false,
  children,
}) => (
  <Observe option={option} value={value} lazy={lazy} unset={unset}>
    <div className={ style.choice } data-color={ color }>
      { children }
    </div>
  </Observe>
)
export default Choice